// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Public
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Works from "./pages/Works";
import ProductDetail from "./pages/ProductDetail";
import ScrollToTop from "./components/ScrollToTop";

// Admin
import Login from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import ProductsAdmin from "./pages/admin/ProductsAdmin";
import WorksAdmin from "./pages/admin/WorksAdmin";
import AdminHeroSlides from "./pages/admin/AdminHeroSlides";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Remonte en haut à chaque changement de route */}
        <ScrollToTop />

        {/* Layout pleine hauteur pour coller le footer en bas */}
        <div className="d-flex flex-column min-vh-100">
          <NavBar />

          {/* Le contenu s'étire pour pousser le footer */}
          <main className="flex-grow-1">
            <Routes>
              {/* Public */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/:dept/products" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/:dept/works" element={<Works />} />

              {/* Admin */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="products" replace />} />
                <Route path="products" element={<ProductsAdmin />} />
                <Route path="works" element={<WorksAdmin />} />
                {/* enfant imbriqué: pas de slash en tête */}
                <Route path="slides" element={<AdminHeroSlides />} />
              </Route>

              {/* 404 */}
              <Route
                path="*"
                element={<div className="container py-5">Page introuvable</div>}
              />
            </Routes>
          </main>

          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
